module.exports = __webpack_public_path__ + "img/user-sample.2cd8c31d.png";